import { useEffect, useState } from 'react'

export function useDynamicCss(href: string): boolean {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    const id = `dynamic-css-${href}`
    if (document.getElementById(id)) {
      setLoaded(true)
      return
    }

    const link = document.createElement('link')
    link.id = id
    link.rel = 'stylesheet'
    link.href = href
    link.type = 'text/css'
    link.media = 'all'
    link.onload = () => setLoaded(true)

    document.head.appendChild(link)

    return () => {
      // opzionale: rimozione
    }
  }, [href])

  return loaded
}
